import { render, staticRenderFns } from "./RemoveFranchiseReasonModal.vue?vue&type=template&id=64e6d7a7&scoped=true&"
import script from "./RemoveFranchiseReasonModal.vue?vue&type=script&lang=js&"
export * from "./RemoveFranchiseReasonModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveFranchiseReasonModal.vue?vue&type=style&index=0&id=64e6d7a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e6d7a7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
